import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/DaftarRegisterPasien";
import { userModule } from "@/store/modules/user";
import { isDaftarPasienTanpaFilterDokter } from "@/utils/unit";
import {
  DashboardDokterCards,
  DashboardDokterData,
  DashboardDokterParams,
  TrenKunjunganDokterData,
  TrenKunjunganParams
} from "@/types/daftarRegisterPasien";

let fetchToken = 0;
let trenToken = 0;

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "dashboard-dokter"
})
class DashboardDokterStore extends VuexModule {
  loading = false;
  isDpjp = false;
  tanggal: string | null = null;
  cards: DashboardDokterCards | null = null;
  trenLoading = false;
  tren: TrenKunjunganDokterData | null = null;

  @Mutation
  SET_DATA(payload: DashboardDokterData | null) {
    this.isDpjp = payload ? !!payload.is_dpjp : false;
    this.tanggal = payload ? payload.tanggal : null;
    this.cards = payload ? payload.cards : null;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_TREN(payload: TrenKunjunganDokterData | null) {
    this.tren = payload;
  }

  @Mutation
  SET_TREN_LOADING(val: boolean) {
    this.trenLoading = val;
  }

  @Action({ rawError: true })
  async fetch(fresh = false): Promise<void> {
    const token = ++fetchToken;
    const unitId = userModule.user?.unit_id ?? "";
    const params: DashboardDokterParams = { unit_id: unitId };

    if (isDaftarPasienTanpaFilterDokter(unitId)) {
      params.semua_dokter = 1;
    }

    if (fresh) {
      params.fresh = 1;
    }

    this.SET_LOADING(true);

    const resp = await Service.getDashboardDokter(params).catch(() => null);

    if (token !== fetchToken) {
      return;
    }

    this.SET_LOADING(false);
    this.SET_DATA(resp && resp.data ? resp.data : null);
  }

  @Action({ rawError: true })
  async fetchTren(params: TrenKunjunganParams): Promise<void> {
    const token = ++trenToken;

    this.SET_TREN_LOADING(true);

    const resp = await Service.getTrenKunjunganDokter(params).catch(
      () => null
    );

    if (token !== trenToken) {
      return;
    }

    this.SET_TREN_LOADING(false);
    this.SET_TREN(resp && resp.data ? resp.data : null);
  }

  @Action({ rawError: true })
  reset(): void {
    fetchToken++;
    trenToken++;
    this.SET_DATA(null);
    this.SET_TREN(null);
    this.SET_LOADING(false);
    this.SET_TREN_LOADING(false);
  }
}

export default getModule(DashboardDokterStore);
